/* @flow */
import { logError } from '../sentry';
import {
  SUPPLY_MONITORING_EVENT_TYPE,
  OptionalSupplyMonitoringEventFields
} from './supply-monitoring-events.type';
import { ConfigStore } from '../stores/config.store';
import { AdContextStore } from '../stores/ad-context.store';
import { sendSupplyMonitoringEvent as sendSupplyMonitoringEventCore } from 'common/services/supply-monitoring-event.service';

export function sendSupplyMonitoringEvent(
  event: SUPPLY_MONITORING_EVENT_TYPE,
  additionalFields?: OptionalSupplyMonitoringEventFields,
  forceSend?: boolean
): Promise<void> {
  const adContext = AdContextStore.getInstance()?.adContext;
  if (!adContext) return Promise.resolve();

  return sendSupplyMonitoringEventCore(
    event,
    adContext,
    ConfigStore.getInstance().config,
    additionalFields,
    forceSend
  ).catch(logError) as Promise<void>;
}
